export const getApiValidationErrors = <
  T extends string | Record<string, any> = string
>(
  error: any
): Record<T extends string ? T : keyof T, string[]> | null => {
  if (error?.response?.status === 422 && error.response.data?.errors) {
    return error.response.data.errors;
  }

  return null;
};
